// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__ZvEEV","section-1":"styles_section-1__nNNer","content":"styles_content__cmdno","section-2":"styles_section-2__JuU39"};